import React from "react";
import { Link, LinkProps } from "react-router-dom";

export function LinkUnset(props: Readonly<LinkProps>): React.ReactElement {
    return <Link {...props} style={{ all: "unset" }} />;
}
